module.exports = __webpack_public_path__ + "img/sample_02_big.d80ee538.gif";